/**
 * Base URL for files deployed with the app (same folder as index.html).
 * Needed when the app is hosted under an IIS virtual directory or subpath
 * (e.g. https://server/OneStop/) so /pages/... and /env.json resolve correctly.
 */
export function getStaticBaseUrl() {
    if (typeof window === 'undefined')
        return '/';
    const { origin, pathname } = window.location;
    if (pathname === '/' || pathname === '' || pathname === '/index.html') {
        return `${origin}/`;
    }
    const basePath = pathname.endsWith('/') ? pathname : pathname.replace(/\/[^/]+$/, '/');
    return `${origin}${basePath}`;
}
/**
 * Prefix root-absolute paths with the app base. Leaves http(s), data URLs, and
 * protocol-relative URLs unchanged.
 */
export function resolvePublicUrl(path) {
    if (path == null || path === '')
        return path;
    if (path.startsWith('http') || path.startsWith('data:') || path.startsWith('//'))
        return path;
    if (!path.startsWith('/'))
        return path;
    const base = getStaticBaseUrl().replace(/\/?$/, '/');
    const rel = path.replace(/^\//, '');
    return `${base}${encodeURI(rel)}`;
}
